/* eslint no-unused-vars: 0 */
import Transition from 'bootstrap/js/transition';
import Modal from 'bootstrap/js/modal';

export default function( $ ) {}
